// The translation stack (i18next and the EN/ES locale files) is loaded on demand, not with the entry bundle
// (docs/cloud/reports/public-mobile-lcp.md): the public Director pages carry their own copy and never use it, so a
// visitor to /services no longer downloads every Panel string before the page can paint. Every route that does
// use it (Panel, sign-in, the NFC and Web Studio pages) is declared with lazyWithI18n (lazyRetry.js), which
// waits for this before the page renders. The axios error text (Q-PAN-06) is installed in the same step, since it
// translates through i18n and only the Panel shows it.
let pending = null;

export function loadI18n() {
  if (!pending) {
    pending = Promise.all([import("../i18n"), import("axios"), import("./axiosErrorText")]).then(
      ([{ default: i18n }, { default: axios }, { installAxiosErrorText }]) => {
        installAxiosErrorText(axios, i18n);
        return i18n;
      },
    );
    // a failed load (flaky connection) may be retried by the next route that asks
    pending.catch(() => {
      pending = null;
    });
  }
  return pending;
}
